<template>
  <div>
    <div class="page-actions">
      <span>币种： </span>
      <el-select v-model="coinType" placeholder="请选择币种">
        <el-option
          v-for="item in coinList"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <span>是否排除机器人：</span>
      <el-switch v-model="exclude"></el-switch>
      <span>关键词： </span>
      <el-input
        v-model="keywords"
        placeholder="如：用户ID，电话，邮箱"
      ></el-input>
      <el-button type="primary" @click="search({ page: 1 })">搜索</el-button>
      <a :href="downloadLink" target="_blank">导出Excel</a>
      <a :href="downloadLinks" target="_blank">导出所有Excel</a>
    </div>
    <div class="counts">
      <span>总数：</span>
      <span>{{ totalCount }}</span>
      <span></span>
      <span></span>
      <span>{{ amoutASum }}</span>
      <span>{{ frozeSum }}</span>
    </div>
    <el-table :data="currencies">
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column prop="tel" label="手机号码"></el-table-column>
      <el-table-column prop="email" label="邮箱地址"></el-table-column>
      <el-table-column prop="coinAmount" label="账户资产"></el-table-column>
      <el-table-column prop="coinFroze" label="冻结资产"></el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import qs from 'qs';
import Pagination from 'components/pagination';

export default {
  name: 'assets',
  data() {
    return {
      // times:[],
      coinType: '',
      keywords: '',
      exclude: false
    };
  },

  computed: {
    ...mapState('assets', [
      'currencies',
      'pagination',
      'totalCount',
      'coinList',
      'amoutASum',
      'frozeSum'
    ]),
    downloadLink() {
      const data = {
        keywords: this.keywords,
        coinType: this.coinType,
        ...this.pagination
      };
      const params = qs.stringify(data);
      return `/la/admin/property/export?${params}`;
    },
    downloadLinks() {
      const data = {
        keywords: this.keywords,
        coinType: this.coinType,
        status: 1
      };
      const params = qs.stringify(data);
      return `/la/admin/property/export?${params}`;
    }
  },
  methods: {
    ...mapActions('assets', ['list']),
    ...mapMutations('assets', ['setpage']),
    search(data) {
      this.list({
        keywords: this.keywords,
        coinType: this.coinType,
        exclude: this.exclude,
        ...this.pagination,
        ...data
      });
    },
    pageChanged(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', {
        pagination,
        coinType: this.coinType,
        keywords: this.keywords,
        exclude: this.exclude
      });
    }
  },
  components: {
    Pagination
  }
};
</script>

<style lang="less" scoped>
.el-table {
  ::v-deep.cell {
    text-align: center;
  }
}
.counts {
  display: flex;
  border: 1px solid #ddd;
  span {
    width: 16.6%;
    line-height: 45px;
    border-right: 1px solid #ddd;
    text-align: center;
  }
}
</style>
